import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { useJobCreation } from "./JobCreationContext";
import { window } from "mixpanel-browser/src/window";
import JobButtons from "./Job-Buttons";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Styles/Job-Description.css";
import { message, Button } from "antd";
import CreateJobLoadingOverlay from "./CreateJobLoadingOverlay";

const JobDescription = () => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const navigate = useNavigate();
  // const [form] = Form.useForm();
  const { jobData, updateJobData } = useJobCreation();
  const location = useLocation();
  const { jobEdit, jobData: passedJobData } = location.state || {};
  // const quillRef = useRef(null);

  const [description, setDescription] = useState("");
  const [showTemplate, setShowTemplate] = useState(true);
  const [wordCount, setWordCount] = useState("");

  const defaultTemplate = `
    <p class="template-note">You can edit or replace the suggested template below.</p>
    <p><strong>Tips:</strong> Provide a summary of the role, what success in the position looks like, and how this role fits into the organization overall.</p>
    <p><strong>Responsibilities</strong></p>
    <ul>
      <li>Be specific when describing each of the responsibilities. Use gender-neutral, inclusive language.</li>
      <li>Example: Determine and develop user requirements for systems in production to ensure maximum usability.</li>
    </ul>
    <p><strong>Qualifications</strong></p>
    <ul>
      <li>Skills, Education, Experience, or Certifications.</li>
      <li>Example: Excellent verbal and written communication skills.</li>
    </ul>
  `;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
     //console.log("👉 JobData when entering Description page:", jobData);
     // console.log("👉 PassedJobData from location.state:", passedJobData);

    const existingDesc = passedJobData?.description || jobData.description;
    if (
      jobEdit &&
      existingDesc &&
      getTextFromHTML(existingDesc).trim() !== ""
    ) {
      setDescription(existingDesc);
      updateJobData("description", existingDesc);
      setWordCount(countWords(existingDesc));
    } else if (
      !jobEdit &&
      jobData.description &&
      getTextFromHTML(jobData.description).trim() !== ""
    ) {
      setDescription(jobData.description);
      setWordCount(countWords(jobData.description));
    }

      return () => {
    // 👈 when leaving this page
    //console.log("👋 JobData when leaving Description page:", jobData);
  };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Minimal Quill Editor configuration - only allows line breaks/paragraphs
  const quillModules = {
    toolbar: false, // Disable all toolbar options
    keyboard: {
      bindings: {
        // Allow only basic text input and line breaks
        "list autofill": false,
        header: false,
      },
    },
  };

  // Custom formats - only allow basic paragraph formatting
  const quillFormats = [
    "header", // This allows paragraph breaks but no other formatting
  ];

  const getTextFromHTML = (html) => {
    const clean = DOMPurify.sanitize(html);
    const temp = document.createElement("div");
    temp.innerHTML = clean;
    return temp.textContent || temp.innerText || "";
  };

  const countWords = (html) => {
    const text = getTextFromHTML(html);
    return text.trim().split(/\s+/).filter(Boolean).length;
  };

  const handleChange = (value) => {
    setDescription(value);
    updateJobData("description", value);
    setWordCount(countWords(value));
  };

  const handleNext = () => {
    const plainText = getTextFromHTML(description).trim();
    if (!plainText) {
      message.error("Please provide a job description before proceeding.");
      return;
    }

      //console.log("✅ JobData before navigating from Description:", jobData);
      
    setButtonLoading(true);
    setTimeout(() => {
      navigate("/jobs/job-admin/job-posts/create-job/media&finalize");
    }, 1500);
  };

  if (buttonLoading) {
    return (
      <CreateJobLoadingOverlay
        image="https://res.cloudinary.com/diomlp95m/image/upload/v1752735823/Youthplus_Logoo_pjfjku.jpg"
        message="Saving Description Details..."
      />
    );
  }

  return (
    <>
      <div className="job-description-head">
        <h2 className="job-description-title">Job Description</h2>
      </div>

      <div className="template-info-box">
        <div className="template-header">
          <h4>Job Description Template</h4>
          <Button type="link" onClick={() => setShowTemplate(!showTemplate)}>
            {showTemplate ? "Hide" : "Show"}
          </Button>
        </div>
        {showTemplate && (
          <div
            className="template-content"
            dangerouslySetInnerHTML={{ __html: defaultTemplate }}
          />
        )}
      </div>

      <div
        className="job-description-container"
        style={{ marginBottom: "4rem" }}
      >
        {/* Quill Editor with minimal formatting - only line breaks allowed */}
        <ReactQuill
          theme="snow"
          value={description}
          onChange={handleChange}
          modules={quillModules}
          formats={quillFormats}
          placeholder="Enter job description here..."
          style={{
            height: "300px",
          }}
        />
      </div>
      <div className="word-count-display">Word Count: {wordCount}</div>

      <JobButtons
        showPrevious={true}
        continueText={"Next"}
        onContinue={handleNext}
      />
    </>
  );
};

export default JobDescription;
